import type { BrandSpecialRules, BrandSpecialType } from '@iheartjane/types';
import uniq from 'lodash-es/uniq';

const normalizeUserSegmentIds = (
  userSegmentIds: number | number[] | null | undefined
): number[] => {
  if (userSegmentIds === null || userSegmentIds === undefined) {
    return [];
  }
  if (Array.isArray(userSegmentIds)) {
    return userSegmentIds.filter(Boolean);
  }
  return [userSegmentIds];
};

export const extractUserSegments = ({
  rules,
  specialType,
}: {
  rules: BrandSpecialRules;
  specialType: BrandSpecialType;
}) => {
  if (!rules) return { includes: [], excludes: [] };

  if (specialType === 'product') {
    const includes = uniq(
      rules?.includes?.flatMap((rule) =>
        normalizeUserSegmentIds(rule.user_segment_ids)
      ) || []
    );
    const excludes = uniq(
      rules?.excludes?.flatMap((rule) =>
        normalizeUserSegmentIds(rule.user_segment_ids)
      ) || []
    );

    return {
      includes,
      excludes,
    };
  }

  const includes = uniq(
    rules?.base?.includes?.flatMap((rule) =>
      normalizeUserSegmentIds(rule.user_segment_ids)
    ) || []
  );

  const excludes = uniq(
    rules?.base?.excludes?.flatMap((rule) =>
      normalizeUserSegmentIds(rule.user_segment_ids)
    ) || []
  );

  return {
    includes,
    excludes,
  };
};
